import Component from "@glimmer/component";
import { service } from "@ember/service";
import { task } from "ember-concurrency";
import { post } from "glesys-controlpanel/data/builders";

export default class ModalsGenerateAuthCode extends Component {
  @service modal;
  @service store;

  get domain() {
    return this.args.params.domain;
  }

  generateAuthCode = task(async () => {
    const { content } = await this.store.request(
      post("domain/generateauthcode", { domainname: this.domain.domainname }),
    );
    return content;
  });
}
